import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { getImageUrl } from '@culture/common-helpers/cultureUtils';

import LazyLoadImage from 'components/LazyLoad/Image';
import { FilePropType } from 'propTypes/common';
import { ImageFormatContext } from 'contexts/ImageFormatContext';

import styles from './styles.module.scss';

const ImagePreview = ({ thumbnailFile: file }) => {
	const imageFormat = useContext(ImageFormatContext);

	const imageSrc =
		file &&
		getImageUrl(file, {
			format: imageFormat,
			params: {
				crop: 'fill',
				gravity: 'center',
				sizeImage: { width: 884 }
			}
		});

	if (!file) {
		return null;
	}

	return (
		<div>
			<LazyLoadImage {...{ imageSrc }}>
				<img className={styles.ImagePreview__Image} src={imageSrc} alt="" />
			</LazyLoadImage>
		</div>
	);
};

ImagePreview.propTypes = {
	thumbnailFile: PropTypes.shape({
		file: FilePropType
	}).isRequired
};

export default ImagePreview;
